// ── SCROLL-DRIVEN SHIRT REVEAL v2 ──
// Drives:
//   1. Shirt LIFT  : translateY on #shirtLayer
//   2. Shirt CURL  : scaleY + rotateX + mask cutoff on #shirtCurl
//   3. Comfort Band fade-in on #bandLayer
//   4. THREE sequential patent stages on #patent1/2/3 (each with its own
//      threshold + scan-line trigger via .revealing / .revealed classes)
//   5. Step text crossfade + progress dots
//
// All scroll math is in normalised progress (0..1) over the height of
// .reveal-wrap. Tuning constants live at the top so feel can be dialled
// without hunting through the file.
(function () {
  const revealWrap = document.querySelector('.reveal-wrap');
  if (!revealWrap) return;

  const shirtLayer = document.getElementById('shirtLayer');
  const shirtCurl  = document.getElementById('shirtCurl');
  const bandLayer  = document.getElementById('bandLayer');

  const patents = [
    document.getElementById('patent1'),
    document.getElementById('patent2'),
    document.getElementById('patent3'),
  ].filter(Boolean);

  const steps = [
    document.getElementById('step1'),
    document.getElementById('step2'),
    document.getElementById('step3'),
  ].filter(Boolean);

  const progs = [
    document.getElementById('prog1'),
    document.getElementById('prog2'),
    document.getElementById('prog3'),
  ].filter(Boolean);

  // ── TUNING ────────────────────────────────────────────────────────────
  // Lift window: scroll progress range over which the shirt animates from
  // resting → fully lifted. Tighter window = more dramatic per-pixel
  // response. v0.1 used 0.25 → 0.65 (window of 0.40); v2 starts sooner
  // and ends sooner so the animation kicks in immediately on scroll.
  const LIFT_START   = 0.10;
  const LIFT_END     = 0.55;

  const MAX_LIFT_PX  = 260;   // upward translateY at full lift (px)
  const MAX_CURL_DEG = 14;    // hem rotateX at full curl (degrees)
  const MAX_SCALE_Y  = 0.18;  // scaleY compression amount (1 → 1 - this)
  const MAX_MASK_PCT = 32;    // % of the shirt's bottom that the curl mask eats

  // Patent reveal thresholds — raw scroll progress (NOT lift progress).
  // Each patent crossfades in over PATENT_FADE worth of progress.
  const PATENT_THRESHOLDS = [0.55, 0.68, 0.80];
  const PATENT_FADE       = 0.10;

  // Step copy crossfade thresholds
  const STEP_2_AT = 0.32;
  const STEP_3_AT = 0.82;
  // ──────────────────────────────────────────────────────────────────────

  const clamp = (v, a, b) => Math.min(Math.max(v, a), b);
  // easeOutQuart — snappier than cubic. Felt right for "small input,
  // big visual" responsiveness without becoming jittery.
  const easeOutQuart = t => 1 - Math.pow(1 - t, 4);

  let ticking = false;

  function update() {
    ticking = false;

    const rect     = revealWrap.getBoundingClientRect();
    const total    = revealWrap.offsetHeight - window.innerHeight;
    const scrolled = -rect.top;
    const progress = total > 0 ? clamp(scrolled / total, 0, 1) : 0;

    // ── 1 + 2. shirt lift + curl ──
    const liftRaw = clamp((progress - LIFT_START) / (LIFT_END - LIFT_START), 0, 1);
    const eased   = easeOutQuart(liftRaw);

    if (shirtLayer) {
      shirtLayer.style.transform =
        'translateX(-50%) translateY(' + (-eased * MAX_LIFT_PX).toFixed(2) + 'px)';
    }

    if (shirtCurl) {
      const scaleY  = (1 - eased * MAX_SCALE_Y).toFixed(4);
      const rotateX = (-eased * MAX_CURL_DEG).toFixed(2);
      shirtCurl.style.transform =
        'scaleY(' + scaleY + ') rotateX(' + rotateX + 'deg)';
      shirtCurl.style.setProperty('--curl-mask',    (eased * MAX_MASK_PCT).toFixed(2) + '%');
      shirtCurl.style.setProperty('--curl-opacity', eased.toFixed(3));
    }

    // ── 3. band container fades in slightly behind the lift ──
    if (bandLayer) {
      const bandFade = clamp((eased - 0.30) / 0.40, 0, 1);
      bandLayer.style.opacity = bandFade.toFixed(3);
    }

    // ── 4. sequential patent reveal ──
    patents.forEach((el, i) => {
      const t   = PATENT_THRESHOLDS[i];
      const amt = clamp((progress - t) / PATENT_FADE, 0, 1);
      el.style.setProperty('--patent-amt', amt.toFixed(3));
      // .revealing fires the scan-line keyframe (CSS-side, runs once)
      if (amt > 0.02) el.classList.add('revealing');
      else            el.classList.remove('revealing');
      // .revealed enables the steady-state pulsing outline
      if (amt >= 0.98) el.classList.add('revealed');
      else             el.classList.remove('revealed');
    });

    // ── 5. step copy crossfade + progress dots ──
    let stepIdx = 0;
    if      (progress >= STEP_3_AT) stepIdx = 2;
    else if (progress >= STEP_2_AT) stepIdx = 1;

    steps.forEach((s, i) => s.classList.toggle('active', i === stepIdx));
    progs.forEach((p, i) => p.classList.toggle('active', i === stepIdx));
  }

  // rAF throttle so high-refresh displays don't fire update() per scroll event
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();
